<template>
  <success :show-promotes='showPromotes'>
    <thanks :email='email' :title='title'>
      <template v-if='isNeedAssignsUser'>
        <span slot='subtitle' v-html="$t('billing.success.downgrade_txt')" />
        <subtitle :sub-title='assignText' />
        <div>
          <user-management-cta :cta-name="$t('billing.success.unassign_users')" />
          <view-account type='plain' />
        </div>
      </template>
      <template v-else-if='isDownsell'>
        <span slot='subtitle' v-html="$t('billing.success.downgrade_txt')" />
        <view-account />
      </template>
      <template v-else-if='isUpsell'>
        <subtitle :sub-title="$t('billing.success.confirmation.user_assign_desc')" />
        <user-management-cta :cta-name="$t('billing.success.confirmation.user_cta')" />
      </template>
      <template v-else>
        <view-account />
      </template>
      <download-action v-if='isShowDownload' />
    </thanks>
  </success>
</template>

<script>
import Success from '@/views/succezz/facade.vue';
import Thanks from '@/views/succezz/thanks-template';
import DownloadAction from '@/views/succezz/thanks-template/download-action.vue';
import { mapGetters, mapState } from 'vuex';
import ViewAccount from '@/views/succezz/thanks-template/view-account.vue';
import UserManagementCta from '@/views/succezz/thanks-template/user-management-cta.vue';
import { dateTimeFormat } from '@/utils/dateformat';
import Subtitle from '@/views/succezz/thanks-template/subtitle.vue';
import { isBoolean } from 'lodash';
import common from '@/views/succezz/mixin/common';

export default {
  mixins: [common],
  components: {
    Subtitle,
    UserManagementCta,
    ViewAccount,
    DownloadAction,
    Success,
    Thanks,
  },
  computed: {
    ...mapGetters(['boughtPlans', 'getCurrentBasePlanInfo', 'successConfig', 'persistState']),
    ...mapState({
      currentEditPlan: (state) => state.ShoppingCart.currentEditPlan,
    }),
    isShowDownload() {
      // only for NN
      if (this.$context.is.buyNow) return true;
      return false;
    },
    currentUpdatedPlan() {
      if (this.currentEditPlan?.plan_code) {
        const plan = this.boughtPlans.find(p => p.plan_code === this.currentEditPlan?.plan_code);
        return plan || { cartInfo: {} };
      }
      return { cartInfo: {} };
    },
    currentSelectedPlan() {
      if (this.currentEditPlan?.plan_code) {
        const plan = this.getSelectedPlans.find(p => p.plan_code === this.currentEditPlan?.plan_code);
        return plan || { cartInfo: {} };
      }
      return { cartInfo: {} };
    },
    isNeedAssignsUser() {
      if (this.unassignLicenses) {
        return true;
      }
      return false;
    },
    unassignLicenses() {
      const quantity = this.persistState.downgradeState?.unAssignLicenseQuantity;
      return quantity > 0 ? quantity : false;
    },
    billingDate() {
      return dateTimeFormat(this.persistState.downgradeState?.planExpireTime);
    },
    assignText() {
      return this.$t('billing.success.downgrade_unassign_licenses', [this.unassignLicenses, this.billingDate]);
    },
    isLicenseIncrease() {
      return (this.currentSelectedPlan?.cartInfo?.selected_number > this.currentEditPlan?.cartInfo?.selected_number);
    },
    isLicenseDecrease() {
      return (this.currentSelectedPlan?.cartInfo?.selected_number < this.currentEditPlan?.cartInfo?.selected_number);
    },
    isDownsell() {
      if (!this.$context.is.edit) return false;
      if (this.isNeedAssignsUser) return true;
      if (this.isLicenseDecrease) return true;
      const { has_downgrade_request, has_decrease_request, has_same_pending_plan } = this.currentUpdatedPlan.cartInfo;
      return (has_downgrade_request || has_decrease_request || has_same_pending_plan);
    },
    isUpsell() {
      if (!this.$context.is.edit) return false;
      if (this.isLicenseIncrease) return true;
      return isBoolean(this.isDownsell) && !this.isDownsell;
    },
    showPromotes() {
      return false;
    },
    getSelectedPlans() {
      return this.persistState.confirmationDetails.getSelectedPlans;
    },
    originalBoughtPlans() {
      return this.persistState.confirmationDetails.boughtPlans;
    },
  },
};
</script>
